/* eslint-disable no-undef */
import helpers from '../helpers';
import _throttle from 'lodash.throttle';
import {agentsPage} from './request-simple';

const $header = document.querySelector('.header');

let windowWidth = innerWidth;
let headerHeight = $header.clientHeight;
let statsPercent = false;

const isFixed = () => $header.classList.contains('header--fixed');

const changeFixedState = (state) => {
	if (state) {
		$header.classList.remove('header--disable-fixed');
		$header.classList.add('header--fixed');
	} else {
		$header.classList.remove('header--fixed');
		$header.classList.add('header--disable-fixed');
	}
};

const changeFixedStateOnScroll = () => {
	if (window.pageYOffset > headerHeight && !isFixed()) {
		changeFixedState(true);
	} else if (window.pageYOffset <= headerHeight && isFixed()) {
		changeFixedState(false);
	}
};

const getScrollPercentage = () => {
	let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	let windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	let documentHeight = Math.max(
		document.body.scrollHeight,
		document.body.offsetHeight,
		document.body.clientHeight,
		document.documentElement.scrollHeight,
		document.documentElement.offsetHeight,
		document.documentElement.clientHeight,
	);

	return scrollTop / (documentHeight - windowHeight) * 100;
};

const resize = () => {
	if (windowWidth === innerWidth) {
		return;
	}

	$header.classList.remove('header--fixed');

	windowWidth = innerWidth;
	headerHeight = $header.clientHeight;

	changeFixedStateOnScroll();
};

const init = () => {
	helpers.$header = $('.header');
	window.addEventListener('resize', _throttle(resize, 500), false);
	window.addEventListener('scroll', _throttle(changeFixedStateOnScroll, 100), false);

	document.addEventListener('DOMContentLoaded', () => {
		window.onscroll = () => {
			if (!statsPercent && getScrollPercentage() > 70) {
				if (agentsPage) {
					ym(25538402, 'reachGoal', 'scroll70');
					gtag('event', 'page70', {
						event_category: 'scroll',
						event_label: 'label',
						value: 'value',
					});

					statsPercent = true;
				} else {
					ym(25538402, 'reachGoal', 'scroll70');
					// ga('send', 'event', 'scroll', 'page70');

					statsPercent = true;
				}
			}
		};
	});
};

export default {
	init,
};
